export const saveStringAsFile = (content, filename = "export.txt") => {
    const encodedContent = new TextEncoder().encode(content);
    const blob = new Blob([ encodedContent ], { type: "text/plain;charset=utf-8" });

    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
    } else {
        const a = window.document.createElement("a");

        a.href = window.URL.createObjectURL(blob);
        a.download = filename;
        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
    }
};

export const uploadJSONFile = (file, onUpload) => {
    const reader = new FileReader();

    reader.onload = function(readerEvt) {
        const data = readerEvt.target.result;
        let config = {};

        try {
            if(data[0] === "\"") {
                let objJsonB64 = decodeURIComponent(data).slice(1, -1);

                // eslint-disable-next-line
                eval( "config = " + objJsonB64 );
            } else {
                config = JSON.parse(data);
            }
        } catch (error) {
            console.error(error);
        }

        onUpload(config);
    };

    reader.readAsText(file);
};
